import { type ApiResponse } from '@/api/core/_models';
import { createMockTrainingRequests } from './_mockRequests';
import { type LessonCompletionInput, type MyCourse, type MyCourseDetail, type TeamBoard } from './_models';

const trainingMockRequests = createMockTrainingRequests();

export function listMyCourses(): Promise<ApiResponse<MyCourse[]>> {
  return trainingMockRequests.listMyCourses();
}

export function getMyCourse(courseId: string): Promise<ApiResponse<MyCourseDetail>> {
  return trainingMockRequests.getMyCourse(courseId);
}

export function setLessonCompletion(
  courseId: string,
  input: LessonCompletionInput,
): Promise<ApiResponse<MyCourseDetail>> {
  return trainingMockRequests.setLessonCompletion(courseId, input);
}

export function getTeamBoard(): Promise<ApiResponse<TeamBoard>> {
  return trainingMockRequests.getTeamBoard();
}
